import { ErrorType } from '../global/types/error';

export function mapError(error: ErrorType) {
  const serverErrorMessage = 'Något gick fel. Försök igen eller kontakta vår support.';

  const message = error?.response?.data?.error;
  const code = error?.response?.status;

  return {
    message: (code ?? 0) < 500 ? message : serverErrorMessage,
    code,
  };
}
